import React from 'react';
import { CockpitInfo } from '@/utils/type';
import { isEmpty } from '@/utils/util';
import classNames from 'classnames';
import './index.scss';
export interface CockpitListData {
  total: number;
  status: 'WORK' | 'REST' | 'OFFLINE';
  cockpitList: {
    cockpitNumber: string;
    onlineUser?: string;
  }[];
}

export interface CockpitGroup {
  workCockpitList: any[];
  restCockpitList: any[];
  offlineCockpitList: any[];
}

const StatusText = {
  WORK: '工作中',
  REST: '休息中',
  OFFLINE: '离线',
};
const CockpitStatus = (props: CockpitListData) => {
  const { total, status, cockpitList } = props;
  return (
    <div className="cockpit-list-content">
      <div className="label">
        <div>{StatusText[status]}</div>
        <div
          className="num"
          style={{
            color:
              status === 'WORK'
                ? '#6AFFF5'
                : status === 'REST'
                ? '#D5E2FF'
                : 'rgba(213,226,255,0.5)',
          }}
        >
          {total}
        </div>
      </div>
      <ul className="cockpit-list">
        {cockpitList?.map((item: any) => (
          <li
            className={classNames('cockpit-item', {
              online: status === 'WORK' || status === 'REST',
              rest: status === 'REST',
              offline: status === 'OFFLINE',
            })}
          >
            <i className="cockpit-number">{item.cockpitNumber}</i>
            <i className="cockpit-ico"></i>
            {item?.cockpitUserName && (
              <i className="user-name">{item.cockpitUserName}</i>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

const CockpitGroup = (props: CockpitGroup) => {
  const { workCockpitList, restCockpitList, offlineCockpitList } = props;
  return (
    <div className="cockpit-group-content">
      <CockpitStatus
        total={workCockpitList?.length}
        status="WORK"
        cockpitList={workCockpitList}
      />
      <CockpitStatus
        total={restCockpitList?.length}
        status="REST"
        cockpitList={restCockpitList}
      />
      <CockpitStatus
        total={offlineCockpitList?.length}
        status="OFFLINE"
        cockpitList={offlineCockpitList}
      />
    </div>
  );
};
export default CockpitGroup;
